var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "#825DFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.76204 13.8265H7.38109C6.8551 13.8265 6.42871 13.3982 6.42871 12.8699L6.42875 7.13009C6.42875 6.60176 6.85515 6.17346 7.38113 6.17346H11.6669C12.1929 6.17346 12.6193 6.60176 12.6193 7.1301V9.04337M13.0954 13.1091L13.5716 13.5874M8.09553 8.08673H10.9527M8.09553 9.52169H10.9527M8.09553 10.9566H9.5241M13.3335 12.1524C13.3335 12.8129 12.8005 13.3482 12.143 13.3482C11.4855 13.3482 10.9525 12.8129 10.9525 12.1524C10.9525 11.492 11.4855 10.9566 12.143 10.9566C12.8005 10.9566 13.3335 11.492 13.3335 12.1524Z",
    stroke: "#825DFC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionDocument);
export default __webpack_public_path__ + "static/media/question-document.6f22f53b0da1d8372b750307cea5ddb1.svg";
export { ForwardRef as ReactComponent };